import React, { useEffect, useState } from 'react'
import SectionTitle from '../../ui/SectionTitle/SectionTitle'
import RequestConsultation from '../../components/RequestConsultation/RequestConsultation'
import FeedsCarousel from '../../components/FeedsCarousel/FeedsCarousel'
import './TextPage.sass'
import getDoc from '../../utils/db/getDoc'
import { find, isEmpty, isNull } from 'lodash'
import parse from 'html-react-parser'
import ReactPlayer from 'react-player'
import ServicePrice from '../../components/ServicePrice/ServicePrice'
import ServicePriceTiles from '../../components/ServicePrice/ServicePriceTiles'

function TextPage({ docId, path }) {
  const [data, setData] = useState(null)
  console.log('🚀 ~ TextPage ~ data:', data)
  useEffect(() => {
    getDoc({
      path,
      docId,
    }).then((res) => setData(res))
  }, [docId])

  return (
    <>
      {/* <div className="TextPage" style={{ backgroundImage: `url(${bgImage})` }}> */}
      <div className="TextPage">
        <div className="TextPage-Container DefaultContainer">
          {!isNull(data) && (
            <>
              <SectionTitle title={data.title} />
              {data.enableProductTiles ? (
                <ServicePriceTiles categoryId={data.categoryId} />
              ) : (
                <ServicePrice categoryId={data.categoryId} />
              )}

              <div className="TextPage-Text">{parse(data.description)}</div>
              <div className="TextPage-Photo">
                <img
                  src={find(data.photos, ['isAvatar', true]).publicUrl}
                  alt=""
                />
              </div>
              {/* {!isEmpty(data) && (
            <>p
              <SectionTitle title={data.title} />
              {!isEmpty(data.video) && (
                <div className="TextPageVideo">
                  <ReactPlayer
                    url={data.video.publicUrl}
                    width="100%"
                    height="100%"
                    controls
                  />
                </div>
              )}

              <div class="TextPage-Text">{parse(data.text)}</div>
            </>
          )} */}
            </>
          )}
        </div>
      </div>
      <RequestConsultation />
    </>
  )
}

export default TextPage
